module.exports = __webpack_public_path__ + "./fonts/Monofonto-Regular.ttf";